export default __webpack_public_path__ + "static/MADLions-a7beeba45d26eda7ef72e4c45573f885.png";